/**
 * Returns true if code is running in local development environment.
 * This is based on the host.
 *
 * @returns true is local dev environment
 */
export const isLocalDev = (): boolean => {
    const { host } = window.location

    return (
        host.startsWith('localhost') ||
        host.startsWith('10.0.2.2') || // Access from VirtualBox
        host.startsWith('10.211.55.2') // Access from Parallels
    )
}
